import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import settings from 'settings';
import ExtendedSelect from 'components/extendedSelect/';
import { Form, Input } from 'antd';
import { list } from 'actions';

import { getActivityLabel, getKey, getSelect } from 'library/helpers';
import { FormWrapper } from 'components/Page';
import REDUCER_KEY from 'reducers/reducer.keys';

const FormItem = Form.Item;
const { TextArea } = Input;

const mapStateToProps = state => ({
  activities: state.api.assignmentActivities.data.results,
  inFlightActivities: state.api.assignmentActivities.inFlight
});

const mapDispatchToProps = dispatch => ({
  loadActivities(searchText = '') {
    // Specify search params
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [{
      id: 'active',
      value: true
    }];
    if (searchText) {
      filters.push({
        id: 'name__icontains',
        value: searchText
      });
    }

    dispatch(list(REDUCER_KEY.assignmentActivities.key, {
      page: 0,
      pageSize: settings.APP_CONFIG.dropListSize,
      filters,
      sorted
    }));
  }
});

const mapPropsToFields = (props) => {
  const { dataSource } = props;

  const {
    activity, notes, admin_notes
  } = dataSource;

  return {
    activity: Form.createFormField({ value: getSelect(activity) }),
    notes: Form.createFormField({ value: notes }),
    admin_notes: Form.createFormField({ value: admin_notes })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  activities, form, inFlightActivities, inputFormItemLayout, loadActivities, showNotes, showAdminNotes
}) => {
  const { getFieldDecorator } = form;

  return (
    <Form>
      <FormItem {...inputFormItemLayout} label="Activity">
        {getFieldDecorator('activity', {
          rules: []
        })(
          <ExtendedSelect
            placeholder="Select Activity"
            fetching={inFlightActivities}
            dataSource={activities}
            optionKey={getKey}
            optionLabel={getActivityLabel}
            onSearch={loadActivities}
            onFocus={loadActivities}
          />
        )}
      </FormItem>
      {showNotes && (
        <FormItem {...inputFormItemLayout} label="Notes">
          {getFieldDecorator('notes', {})(
            <TextArea maxLength={5000} rows={4} />
          )}
        </FormItem>
      )}
      {showAdminNotes && (
        <FormItem {...inputFormItemLayout} label="Admin Notes">
          {getFieldDecorator('admin_notes', {})(
            <TextArea maxLength={5000} rows={4} />
          )}
        </FormItem>
      )}
    </Form>
  );
};

FormInput.propTypes = {
  activities: PropTypes.array,
  inFlightActivities: PropTypes.bool,
  form: PropTypes.object,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func,
  loadActivities: PropTypes.func,
  showNotes: PropTypes.bool,
  showAdminNotes: PropTypes.bool,
  inputFormItemLayout: PropTypes.object
};

FormInput.defaultProps = {
  activities: [],
  inFlightActivities: false,
  form: {},
  onFieldsChange() {
  },
  onValuesChange() {
  },
  loadActivities() {
  },
  showNotes: true,
  showAdminNotes: false,
  inputFormItemLayout: {}
};

const BulkActivityInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(FormInput));

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(BulkActivityInput);
